module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "browse-episode"
  }, [_c('episode', {
    attrs: {
      "episode": _vm.episode
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57330c6f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrowseEpisode.vue
// module id = 40
// module chunks = 0